import { render, staticRenderFns } from "./TagSymbol.vue?vue&type=template&id=f65d5746&lang=pug"
import script from "./TagSymbol.vue?vue&type=script&lang=js"
export * from "./TagSymbol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports